import { apiDocsUrl } from '../../constants/aampeDocsUrls';

import API from '../../services/api';

export default function DocsLogin() {
    API.getDocsAuthToken()
        .then((response) => {
            const docsAuthToken = response.data;
            window.location.href = `${apiDocsUrl}?auth_token=${docsAuthToken}`;
        })
        .catch((error) => {
            console.error('Error fetching docs auth token', error);
        });
    return null;
}
